module.exports = __webpack_public_path__ + "static/media/css3.b675af60.svg";